import  styled  from 'styled-components';
import MuiPaper from '@mui/material/Paper';

export const StyledPaper = styled(MuiPaper)`
  padding: 2rem;
  border-radius: ${({rounded}) => rounded ? '16px !important' : '4px'};
`;